import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getPaymentMethods = async () => {
  return await apiClient.get(`${ENDPOINTS.STRIPE}/payment-methods`);
};
